import { render, staticRenderFns } from "./ViewList.vue?vue&type=template&id=92001408&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/ViewList.vue
// module id = 1130
// module chunks = 0